/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

function FeaturesSection() {
    const { theme } = useTheme();

    const features = [
        {
            icon: 'bi-diagram-3',
            title: 'Visual Schema Designer',
            description: 'Create Tables, set relationships between tables with simple forms. No code or migration files required.'
        },
        {
            icon: 'bi-people',
            title: 'User Management',
            description: 'Create and Manage User accounts per application, enable Sign up'
        },
        {
            icon: 'bi-shield-lock',
            title: 'Role-Based Security',
            description: 'Granular control. Define Read/Write/Delete/Update permissions per role, Table level permissions'
        },
        {
            icon: 'bi-magic',
            title: 'Auto-Generated UI',
            description: 'Stop building CRUD. arcee generates validation-ready interfaces for you.'
        },
        {
            icon: 'bi-building',
            title: 'True Multi-Tenancy',
            description: 'Data Sandboxing ensures each application gets its own isolated tables and credentials.'
        },
        {
            icon: 'bi-search',
            title: 'Smart Search',
            description: 'Integrated full-text search and filtering across your data without extra configuration.'
        },
        {
            icon: 'bi-phone',
            title: 'Mobile Native',
            description: 'Responsive out of the box. Your business apps work perfectly on tablets and phones.'
        },
        {
            icon: 'bi-code-square',
            title: 'API First',
            description: 'Every model automatically exposes a secure, documented OAuth2 API for external integration.'
        }
    ];

    return (
        <section id="features" className="features-section" style={{ padding: '80px 0', background: '#f8f9fa' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                    <p style={{ color: theme.secondary, fontWeight: 600, fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>
                        WHY ARCEE?
                    </p>
                    <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: theme.primary }}>
                        Built for Serious Builders
                    </h2>
                </div>

                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div key={index} className="col-md-6 col-lg-3">
                            <div
                                className="feature-card"
                                style={{
                                    padding: '28px',
                                    background: '#fff',
                                    borderRadius: theme.cardRadius,
                                    height: '100%',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    transition: 'transform 0.2s, box-shadow 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                                }}
                            >
                                <i
                                    className={`${feature.icon} mb-3`}
                                    style={{
                                        fontSize: '2.5rem',
                                        color: theme.primary,
                                        display: 'block'
                                    }}
                                ></i>
                                <h5 style={{ fontWeight: 700, color: theme.primary, marginBottom: '12px' }}>
                                    {feature.title}
                                </h5>
                                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem', lineHeight: 1.6 }}>
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;
